module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"prev_page":"Предыдущая страница","next_page":"Следующая страница","all_pages":"Все"},"en":{"prev_page":"Previous page","next_page":"Next page","all_pages":"All"}}')
  delete Component.options._Ctor
}
